import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import { effects } from './effects';
import { ShapeElementRendererExtension } from './element-renderer';
import { ShapeDomRendererExtension } from './element-renderer/shape-dom';
import { ShapeElementView, ShapeViewInteraction } from './element-view';
import { ShapeTool, WorldMapTool } from './shape-tool';
import { shapeSeniorTool, shapeToolbarExtension } from './toolbar';
import { worldMapSeniorTool } from './toolbar/world-map-tool';

export class ShapeViewExtension extends ViewExtensionProvider {
  override name = 'affine-shape-gfx';

  override effect(): void {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    if (this.isEdgeless(context.scope)) {
      context.register(ShapeElementRendererExtension);
      context.register(ShapeDomRendererExtension);
      context.register(ShapeElementView);
      context.register(ShapeTool);
      context.register(shapeSeniorTool);
      context.register(WorldMapTool);
      context.register(worldMapSeniorTool);
      context.register(shapeToolbarExtension);
      context.register(ShapeViewInteraction);
    }
  }
}
